export default "__VITE_ASSET__BQ1MIM8Q__"